import React from "react";

const CommonContext = React.createContext({});

export const ContextProvider = CommonContext.Provider;
export default CommonContext;